import React from "react";
import "../../Styles/yellowcalf.css/Vehicle_Expense_Report.css";

function Vehicle_Expense_Report() {
  return (
    <div className="vehicle-expense-report-container">
      <div className="special-header panel-white-all">
        <h4 className="page-title">Vehicle Expense Report</h4>
        <button className="btn btn-primary">
          Export <i className="fa fa-angle-down"></i>
        </button>
      </div>

      <div className="yc-list-filter">
        <select id="student_id" className="form-select vehicle-expense-report-select">
          <option value="">All Vehicle</option>
          <option value="189">ssds - hjh45</option>
          <option value="207">hebu - 78787878</option>
          <option value="211">siva - 34567889</option>
          <option value="186">Kaleem - 456</option>
          <option value="222">testing - 34567889</option>
          <option value="101">Mahesh - 546452367</option>
          <option value="224">ritu - 607046</option>
        </select>

        <input
          type="date"
          id="startdate"
          className="form-control vehicle-expense-report-date-input"
          placeholder="Start Date"
        />

        <input
          type="date"
          id="enddate"
          className="form-control vehicle-expense-report-date-input"
          placeholder="End Date"
        />

        <button type="submit" className="btn btn-primary">
          Search
        </button>
        <button type="reset" className="btn btn-primary">
          Clear
        </button>
      </div>
    </div>
  );
}

export default Vehicle_Expense_Report;
